import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const ConfigObject = {
    list: async () => axios.post(API_URL + "/objects/list").then(({data}) => data).catch((err) => { throw err }),
    get: async (id) => axios.get(API_URL + `/objectType/${id}`).then(({data}) => data).catch((err) => { throw err }),
    create: async (data) => axios.post(API_URL + `/objects`, data).then(({data}) => data).catch((err) => { throw err }),
    edit: async (id, data) => axios.post(API_URL + `/objects/${id}`, data).then(({data}) => data).catch((err) => { throw err }),
    destroy: async (id) => axios.delete(API_URL + `/objects/${id}`).then(({data}) => data).catch((err) => { throw err }),


}

export default ConfigObject;
